module.exports = __webpack_public_path__ + "img/5_26@3x.1edaf42a.png";